import AutomationCtrl from './controllers/index';
import AutomationEmailCtrl from "./controllers/email";
import AutomationSmsCtrl from "./controllers/sms";
import automationMessage from "./directives/automation-message";
import automationSettings from "./directives/automation-settings";
import messageDelaySettings from "./directives/message-delay-settings";
import uirouter from 'angular-ui-router';
import routing from './automation.routes';
import Automation from './automation.repository';

export default angular.module('app.automation', [uirouter])
    .config(routing)
    .controller('AutomationCtrl', AutomationCtrl)
    .controller('AutomationEmailCtrl', AutomationEmailCtrl)
    .controller('AutomationSmsCtrl', AutomationSmsCtrl)
    .directive('automationMessage', () => new automationMessage)
    .directive('automationSettings', () => new automationSettings)
    .directive('messageDelaySettings', () => new messageDelaySettings)
    .service('Automation', Automation)
    .name;

